import React from 'react'
import {
  Icon,
  IconProps,
} from '@gousto-internal/citrus-react'
import { FALLBACK_COLOR, FALLBACK_ICON } from '../../../../config/icons'
import css from './TopicBackground.module.css'
import { hex2rgb } from '../../../../utils'

type Nullable<T> = T | null
interface TopicBackgroundProps {
  categoryId: string;
  color?: Nullable<string>;
  iconName?: Nullable<IconProps['name']>;
}

const indexesForIcons = Array.from(Array(13).keys())

export const TopicBackground = ({
  categoryId,
  color = null,
  iconName = null,
}: TopicBackgroundProps) => (
  <div
    className={css.image}
    style={{ backgroundColor: `rgba(${hex2rgb(color || FALLBACK_COLOR)}, 0.13)` }}
  >
    {indexesForIcons.map((index) => (
      <Icon
        // eslint-disable-next-line react/no-array-index-key
        key={`topicBackground-${categoryId}-${index}`}
        name={iconName || FALLBACK_ICON}
        className={`${css.icon} ${css[`clone${index}`]}`}
        style={{ color: color || FALLBACK_COLOR }}
      />
    ))}
  </div>
)
